import React from 'react';
import { useLocation } from 'react-router-dom';
import Events from './Events';

function InfoPanel({ stats, activeTab, onClose }) {
  const location = useLocation();

  if (location.pathname !== '/' || !activeTab) return null;

  return (
    <>
      <div className="info-panel-overlay" onClick={onClose} />
      <div className="info-panel-dropdown">
        {activeTab === 'events' && (
          <div className="info-panel-dropdown-content">
            <Events />
          </div>
        )}
        {activeTab === 'stats' && (
          <div className="info-panel-dropdown-content">
            <div className="stats-grid">
              <div className="stat-card">
                <h3>{stats.total}</h3>
                <p>Pedidos Totales</p>
              </div>
              <div className="stat-card salud">
                <h3>{stats.salud}</h3>
                <p>Categoría Salud</p>
              </div>
              <div className="stat-card paz">
                <h3>{stats.paz}</h3>
                <p>Categoría Paz</p>
              </div>
              <div className="stat-card otros">
                <h3>{stats.otros}</h3>
                <p>Otras Categorías</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default InfoPanel;
